import React from 'react';
import '../style.css';
import { 
  FaPlane,
  FaStar,
  FaCheckCircle,
  FaArrowRight,
  FaPhoneAlt,
  FaCar,
  FaMapMarkerAlt,
  FaTaxi,
  FaUserFriends,
  FaShieldAlt
} from 'react-icons/fa';
import { 
  MdTempleHindu,
  MdSpeed
} from 'react-icons/md';

const CityOfLightPremium = () => {
  const images = [
    {
      url: "https://varanasicabrental.in/wp-content/uploads/2024/08/car-big.jpg",
      title: "Premium Fleet",
      alt: "Luxury Car Taxi Service"
    },
    {
      url: "https://subwaycabs.com/uploads/1700908571_cc93812c424aee69dff5.webp",
      title: "City Rides",
      alt: "City Cab Service"
    },
    {
      url: "https://t4.ftcdn.net/jpg/16/45/93/23/360_F_1645932381_j84ASd71uHsozYICLZNBV1Yyu1Ie9Xe0.jpg",
      title: "Airport Transfers",
      alt: "Airport Taxi Service"
    },
    {
      url: "https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
      title: "Outstation Trips",
      alt: "Outstation Cab Service"
    }
  ];

  const services = [
    {
      icon: <FaPlane />,
      title: "Airport & Railway Transfers",
      description: "Hassle-free transfers from Varanasi Airport & Railway stations"
    },
    {
      icon: <MdTempleHindu />,
      title: "Kashi Darshan Packages",
      description: "Complete temple tours with experienced guides"
    },
    {
      icon: <FaMapMarkerAlt />,
      title: "Dashashwamedh Ghat Tours",
      description: "Ganga Aarti experiences and spiritual tours"
    },
    {
      icon: <FaCar />,
      title: "Luxury Outstation Trips",
      description: "Premium cars for Sarnath, Prayagraj trips"
    }
  ];

  const cabServices = [
    { icon: <FaCar />, name: "Sedan (4 Seater)", price: "₹15/km" },
    { icon: <FaUserFriends />, name: "SUV (6 Seater)", price: "₹20/km" },
    { icon: <FaTaxi />, name: "Innova (7 Seater)", price: "₹25/km" },
    { icon: <MdSpeed />, name: "Swift Dzire", price: "₹12/km" },
    { icon: <FaPlane />, name: "Airport Pickup", price: "₹500" },
    { icon: <FaShieldAlt />, name: "Premium Insurance", price: "Included" }
  ];

  return (
    <section className="city-of-light-premium">
      {/* Floating Background Elements */}
      <div className="floating-element-premium floating-element-premium-1"></div>
      <div className="floating-element-premium floating-element-premium-2"></div>
      
      <div className="container-premium">
        <div className="city-premium-wrapper">
          {/* Left Content */}
          <div className="city-premium-content">
            {/* Header */}
            <div className="city-premium-header">
              <span className="city-premium-tag">
                <FaStar className="city-premium-tag-icon" />
                Premium Service
              </span>
              <h1>
                <span className="city-premium-title-line">The City of Light</span>
                <span className="city-premium-title-highlight">Premium Taxi Service</span>
                <span className="city-premium-title-location">In Varanasi</span>
              </h1>
              
              <div className="city-premium-rating">
                <div className="city-premium-stars">
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />
                </div>
                <span>4.9/5 (5000+ Reviews)</span>
              </div>
            </div>

            {/* Description */}
            <div className="city-premium-description">
              <p>
                Looking for the <strong>VNS Tour And Travels</strong>? Your search ends here! 
                <span className="city-premium-brand"> VNS Tour And Travels </span> 
                offers reliable car rentals and customized tour packages designed to make your journey through the holy city as smooth as the Ganges itself.
              </p>
              
              <div className="city-premium-highlight">
                <div className="city-premium-highlight-icon">
                  <FaMapMarkerAlt />
                </div>
                <p>"Experience Varanasi with comfort, safety, and reliability. We provide 24/7 taxi service with local expert drivers who know every corner of this ancient city."</p>
              </div>
            </div>

            {/* Services Grid */}
            <div className="city-premium-services">
              <h3>Our Premium Services</h3>
              
              <div className="city-premium-services-grid">
                {services.map((service, index) => (
                  <div key={index} className="city-premium-service-card">
                    <div className="city-premium-service-icon">
                      {service.icon}
                    </div>
                    <div className="city-premium-service-content">
                      <h4>{service.title}</h4>
                      <p>{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Features Section */}
            <div className="city-premium-features">
              <h4>Why Choose Us?</h4>
              <div className="city-premium-features-list">
                <div className="city-premium-feature-item">
                  <FaCheckCircle className="city-premium-check-icon" />
                  <span>24/7 Service Available</span>
                </div>
                <div className="city-premium-feature-item">
                  <FaCheckCircle className="city-premium-check-icon" />
                  <span>Local Expert Drivers</span>
                </div>
                <div className="city-premium-feature-item">
                  <FaCheckCircle className="city-premium-check-icon" />
                  <span>Clean & Comfortable Cars</span>
                </div>
                <div className="city-premium-feature-item">
                  <FaCheckCircle className="city-premium-check-icon" />
                  <span>Fixed Transparent Pricing</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right Images Grid */}
          <div className="city-premium-image-side">
            <div className="city-premium-image-grid">
              {images.map((image, index) => (
                <div key={index} className="city-premium-image-container">
                  <div className="city-premium-image-wrapper">
                    <img 
                      src={image.url} 
                      alt={image.alt}
                      loading="lazy"
                      onError={(e) => {
                        e.target.style.background = 'linear-gradient(135deg, #3b82f6, #1e40af)';
                      }}
                    />
                    <div className="city-premium-image-overlay">
                      <span className="city-premium-image-title">{image.title}</span>
                    </div>
                  </div>
                  
                  {/* Image Badge */}
                  {index === 0 && (
                    <div className="city-premium-special-badge">
                      <FaStar className="city-premium-badge-star" />
                      <span>Most Popular</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
            
            {/* Cab Services Sidebar */}
            <div className="city-premium-cab-services">
              <h3>
                <FaTaxi />
                VNS Tour And Travels
              </h3>
              <div className="city-premium-cab-list">
                {cabServices.map((service, index) => (
                  <div key={index} className="city-premium-cab-item">
                    <div className="city-premium-cab-icon">
                      {service.icon}
                    </div>
                    <span>{service.name}</span>
                    <span className="city-premium-cab-price">{service.price}</span>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Stats Bar */}
            <div className="city-premium-stats">
              <div className="city-premium-stat">
                <div className="city-premium-stat-number">10,000+</div>
                <div className="city-premium-stat-label">Happy Customers</div>
              </div>
              <div className="city-premium-stat">
                <div className="city-premium-stat-number">50+</div>
                <div className="city-premium-stat-label">Fleet Size</div>
              </div>
              <div className="city-premium-stat">
                <div className="city-premium-stat-number">24/7</div>
                <div className="city-premium-stat-label">Service</div>
              </div>
              <div className="city-premium-stat">
                <div className="city-premium-stat-number">15+</div>
                <div className="city-premium-stat-label">Years Experience</div>
              </div>
            </div>

            {/* CTA Below Stats */}
            <div className="city-premium-right-cta">
              <div className="city-premium-right-cta-content">
                <button className="city-premium-primary-btn">
                  <span>Book Your Ride Now</span>
                  <FaArrowRight className="city-premium-arrow-icon" />
                </button>
                
                <div className="city-premium-contact">
                  <FaPhoneAlt className="city-premium-phone-icon" />
                  <div>
                    <span className="city-premium-call-text">Call us 24/7</span>
                    <span className="city-premium-phone-number"> 6307291567</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CityOfLightPremium;